import React, { Component } from 'react'
import { Row, Col, Modal, Form, Button } from 'react-bootstrap';
import DateTime from 'react-datetime'
import '../../../../react-datetime.css'
import '../_quiz.scss';
import gql from "graphql-tag";
import { withApollo } from "react-apollo";
import { graphql } from "react-apollo";
import * as compose from 'lodash.flowright';
import moment from 'moment';
import { Link, withRouter } from 'react-router-dom';
import * as Cookies from "es-cookie";

const UPDATE_QUIZ_TIME_PAPER = gql`
  mutation($start_time: String,$end_time: String,$time_duration:Int,$examPaperId:Int) {
    updateTimeQuizPaper(start_time: $start_time,end_time: $end_time,time_duration:$time_duration,examPaperId:$examPaperId)
  }
`;

class EditTimeModal extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            startdate:"",
            loadingSymbol:0,
            enddate:""
         };
    }

    datefunction = (moment, name) => {
        console.log("datefunction", moment._d, name);
        let date = String(moment._d);
        var res = date.substr(4, 20);
        console.log("res", res);
        this.setState({ startdate: res });

        this.setState({
            submitError1: ""
        });
    }
    datefunctionend = (moment, name) => {
        console.log("datefunction", moment._d, name);
        let date = String(moment._d);
        var res = date.substr(4, 20);
        console.log("res", res);
        this.setState({ enddate: res });

    }
   
    submitTime = async (e) => {
        this.setState({
            loadingSymbol: 1
        });

        let startdate="";
        if (this.state.startdate == "") {
            startdate = this.props.start_time_pop;
        }
        else {
            startdate = moment(this.state.startdate, "MMM DD YYYY HH:mm:ss").unix();
        }

        let enddate1="";
        if (this.state.enddate == "") {
            enddate1 = this.props.end_time_pop;
        }
        else {
            enddate1 = moment(this.state.enddate, "MMM DD YYYY HH:mm:ss").unix();
        }

        console.log("aravindDD",this.props.start_time_pop)
        console.log("aravindDD",startdate)

        console.log("aravind",this.props.setTimePaperDetails.id)
        await this.props.updateTimeQuizPaper({
            variables: {
                start_time: startdate.toString(),
                end_time:enddate1.toString(),
                time_duration: parseInt(this.props.extra_time_duration),
                examPaperId: parseInt(this.props.setTimePaperDetails.id)
            },
            update: (store, { data }) => {
                console.log("datadatadatadata",data)
                if (data.updateTimeQuizPaper == true) {
                    this.setState({
                        loadingSymbol: 1
                    });
                   
                   setTimeout(() => {
                        window.location.reload(true)
                    }, 2000);
                     
                }
            }
            
          });

        console.log("aaaa")
    }
    render() {
        var yesterday = DateTime.moment().subtract(1, 'day');

        var valid = function (current) {
            return current.isAfter(yesterday);
        };

        console.log("aravind",this.props.start_time_pop)
        
        return (
            <Modal {...this.props} className='quiz_modal'
                size="md" aria-labelledby="example-modal-sizes-title-lg">
                <Modal.Header closeButton className='p-2'>
                    <Modal.Title><h5 className='modal_title_color'>Schedule Exam Time</h5></Modal.Title>
                </Modal.Header> 
                {/*<Button variant="link" className='closebtn' onClick={() => { this.props.onHide() }}> <i className="fas fa-times" /> </Button>*/}
                <Modal.Body className="p-4">
                   <Row>
                   <Col sm={6}>
                        <Form className="">
                            <Form.Row>
                                <Form.Group as={Col} sm={12} controlId="StartDate">
                                    <Form.Label className="text-uppercase">Set Date & Time</Form.Label>
                                    <DateTime
                                        name="startdate"
                                        dateFormat="DD-MM-YYYY"
                                        inputProps={{ placeholder: 'Ex: 02-04-1995' }}
                                        onChange={this.datefunction}
                                        isValidDate={valid}
                                        defaultValue={moment.unix(this.props.start_time_pop).format("DD-MM-YYYY LT")}
                                    />
                                </Form.Group>
                                
                            </Form.Row>
                        </Form>
                    </Col>
                    <Col sm={6}>
                        {
                                Cookies.get("institutionid") == 19 ?
                                (
                                    <Form className="">
                                        <Form.Row>
                                            <Form.Group as={Col} sm={12} controlId="EndDate">
                                                <Form.Label className="text-uppercase">Set Date & Time</Form.Label>
                                                <DateTime
                                                    name="enddate"
                                                    dateFormat="DD-MM-YYYY"
                                                    inputProps={{ placeholder: 'Ex: 02-04-1995' }}
                                                    onChange={this.datefunctionend}
                                                    isValidDate={valid}
                                                    defaultValue={moment.unix(this.props.end_time_pop).format("DD-MM-YYYY LT")}
                                                />
                                            </Form.Group>
                                            
                                        </Form.Row>
                                    </Form>
                                )
                                :
                                (
                                    <Button type="button"
                                            className="btn btn-light-blue text-uppercase mt-4"
                                            onClick={(e) => {this.submitTime(e)}}> Schedule Quiz Time
                                    </Button>
                                )
                            }
                        </Col>
                   </Row>
                   {
                       Cookies.get("institutionid") == 19 ?
                       (
                        <Row>
                            <Col sm={12}>
                                <Button type="button"
                                    className="btn btn-light-blue text-uppercase mt-4"
                                    onClick={(e) => {this.submitTime(e)}}> Schedule Quiz Time
                                </Button>
                            </Col>
                        </Row>
                       )
                       :
                       ("")
                   }
                   {
                        this.state.loadingSymbol == 1 ?
                        (
                            <Row>
                                <Col sm={12}>
                                    {<div class="spinner-border text-primary"></div>}
                                </Col>
                            </Row>
                        )
                        :
                        ("")
                    }
                </Modal.Body>
            </Modal>
        )
    }
}


export default withRouter(
    compose(
        graphql(UPDATE_QUIZ_TIME_PAPER, {
            name: "updateTimeQuizPaper"
        }),
    )(EditTimeModal)
);

